/* eslint-disable */
import { appConfig } from "src/config";
import { LibCategories } from "src/utils/consent";
import { loadScript } from "src/utils/scriptLoader";

declare const gtag: any;
declare const dataLayer: any;
declare const window: Window & {
  gtag: any;
  dataLayer: any;
};

window.dataLayer = window.dataLayer || [];
window.gtag = function gtag() {
  dataLayer.push(arguments);
};
gtag("js", new Date());
// Adwords Tag
gtag("config", "AW-783925782");

// Add Floodlight container
gtag("config", "DC-13864570");

// General analytics.
gtag("config", "UA-6218573-30");

const GTAG_ID = "AW-783925782";

// Google Tag Gateway first-party measurement path. A Cloudflare Origin Rule
// proxies requests under this path to Google's first-party serving endpoint
// (AW-783925782.fps.goog), but that rule only exists on the production noom.com
// domain. In every other environment the path is not routed and would return
// our SPA's index.html, which the browser then tries to execute as JavaScript
// (throwing "Unexpected token '<'"), so there we load gtag.js straight from
// Google. The path is randomized per Google's recommendation and must match the
// path registered in the Tag Gateway config and the Cloudflare Origin Rule.
const GTG_MEASUREMENT_PATH = "g6na6vx";

function getGtagSrc(): string {
  if (appConfig.NOOM_ENV === "production") {
    return `/${GTG_MEASUREMENT_PATH}/gtag/js?id=${GTAG_ID}`;
  }
  return `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`;
}

export function loadGA() {
  return Promise.all([
    loadScript(getGtagSrc(), [LibCategories.targetingCookies]),
  ]).then(() => {});
}
